import React, { useState, useEffect, useCallback } from 'react';
import { ShoppingCart, FolderOpen, FolderTree } from 'lucide-react';
import Tabs from '../../ui/Tabs.jsx';
import ArticlesModern from '../../ModernTable/ArticlesModern';
import CategoriesModern from '../../ModernTable/CategoriesModern';
import SubcategoriesModern from '../../ModernTable/SubcategoriesModern';

const ArticlesTabs = ({ onTabChange, triggerAddCategory, triggerAddSubCategory, onEditArticle, onRefreshArticles }) => {
    const [articlesCounts, setArticlesCounts] = useState({ articles: 0, categories: 0, subCategories: 0 });

    const fetchArticlesCounts = useCallback(async () => {
        try {
            const response = await fetch('index.php/articles/getNumberOfArticles');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setArticlesCounts({
                articles: data.articles,
                categories: data.categories,
                subCategories: data.subCategories
            });
        } catch (error) {
            console.error('Error fetching articles counts:', error);
        }
    }, []);

    useEffect(() => {
        fetchArticlesCounts();
    }, [fetchArticlesCounts]);

    // Handle refresh callback for when articles are created/updated/deleted
    // Only refreshes counts - does NOT trigger full remount via onRefreshArticles
    // to avoid re-triggering modal open states
    const handleRefresh = useCallback(() => {
        fetchArticlesCounts();
    }, [fetchArticlesCounts]);

    // Full refresh including table data (used when returning from edit view)
    const handleFullRefresh = useCallback(() => {
        fetchArticlesCounts();
        if (onRefreshArticles) {
            onRefreshArticles();
        }
    }, [fetchArticlesCounts, onRefreshArticles]);

    const tabsData = [
        {
            id: 'articles',
            name: 'Artikel',
            icon: ShoppingCart,
            count: articlesCounts.articles,
            content: <ArticlesModern onEdit={onEditArticle} onRefresh={handleRefresh} />
        },
        {
            id: 'categories',
            name: 'Kategorien',
            icon: FolderOpen,
            count: articlesCounts.categories,
            content: <CategoriesModern triggerAdd={triggerAddCategory} onRefresh={handleRefresh} />
        },
        {
            id: 'subCategories',
            name: 'Unterkategorien',
            icon: FolderTree,
            count: articlesCounts.subCategories,
            content: <SubcategoriesModern triggerAdd={triggerAddSubCategory} onRefresh={handleRefresh} />
        }
    ];

    return (
        <div>
            <Tabs
                tabs={tabsData}
                onTabChange={onTabChange}
            />
        </div>
    );
};

export default ArticlesTabs;
